// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetQuarantineDataResponseContent
 */
export interface GetQuarantineDataResponseContent {
    /**
     * 
     * @type {string}
     * @memberof GetQuarantineDataResponseContent
     */
    nextToken?: string;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof GetQuarantineDataResponseContent
     */
    records: Array<{ [key: string]: string; }>;
    /**
     * 
     * @type {number}
     * @memberof GetQuarantineDataResponseContent
     */
    totalFailed?: number;
}

/**
 * Check if a given object implements the GetQuarantineDataResponseContent interface.
 */
export function instanceOfGetQuarantineDataResponseContent(value: object): value is GetQuarantineDataResponseContent {
    if (!('records' in value) || value['records'] === undefined) return false;
    return true;
}

export function GetQuarantineDataResponseContentFromJSON(json: any): GetQuarantineDataResponseContent {
    return GetQuarantineDataResponseContentFromJSONTyped(json, false);
}

export function GetQuarantineDataResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuarantineDataResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
        'records': json['records'],
        'totalFailed': json['totalFailed'] == null ? undefined : json['totalFailed'],
    };
}

export function GetQuarantineDataResponseContentToJSON(json: any): GetQuarantineDataResponseContent {
    return GetQuarantineDataResponseContentToJSONTyped(json, false);
}

export function GetQuarantineDataResponseContentToJSONTyped(value?: GetQuarantineDataResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nextToken': value['nextToken'],
        'records': value['records'],
        'totalFailed': value['totalFailed'],
    };
}
